<ul class="program-list list-group row {{type}} {{className}}">
    <ng-content select="app-content-item-big"></ng-content>
    <ng-content select="app-person-item-big"></ng-content>
</ul>
